import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import ChangeEmail from './ChangeEmail';
import messages from '../../locale/jsonMessages';

export default async function action({ store, intl }) {
  if (!store.getState().runtime.isAuthenticated) return { redirect: '/login' };
  return {
    title: intl?.formatMessage(messages.changeEmailTitle),
    component: <UserLayout><ChangeEmail /></UserLayout>,
  };
}
